module.exports = __webpack_public_path__ + "img/arror_right.666db8a6.png";